(() => {
  const map = Object.freeze({
    // option names
    'farbe': 'Couleur', 'color': 'Couleur', 'colour': 'Couleur',
    'größe': 'Taille', 'grösse': 'Taille', 'groesse': 'Taille', 'size': 'Taille',

    // one-size values
    'einheitsgröße': 'Taille unique', 'einheitsgrösse': 'Taille unique',
    'einheitsgroesse': 'Taille unique', 'one size': 'Taille unique', 'onesize': 'Taille unique',

    // German / English colours that exist in imported products
    'blau': 'Bleu', 'blue': 'Bleu',
    'schwarz': 'Noir', 'black': 'Noir',
    'weiß': 'Blanc', 'weiss': 'Blanc', 'white': 'Blanc',
    'braun': 'Marron', 'brown': 'Marron',
    'rosa': 'Rose', 'pink': 'Rose',
    'grau': 'Gris', 'gray': 'Gris', 'grey': 'Gris',
    'dunkelgrau': 'Gris foncé', 'dark gray': 'Gris foncé', 'dark grey': 'Gris foncé',
    'hellgrau': 'Gris clair', 'light gray': 'Gris clair', 'light grey': 'Gris clair',
    'grün': 'Vert', 'gruen': 'Vert', 'green': 'Vert',
    'dunkelgrün': 'Vert foncé', 'dunkelgruen': 'Vert foncé', 'dark green': 'Vert foncé',
    'hellgrün': 'Vert clair', 'hellgruen': 'Vert clair', 'light green': 'Vert clair',
    'mint green': 'Vert menthe', 'sage green': 'Vert sauge', 'army green': 'Vert militaire',
    'navy': 'Bleu marine', 'navy blue': 'Bleu marine',
    'dunkelblau': 'Bleu foncé', 'dark blue': 'Bleu foncé',
    'hellblau': 'Bleu clair', 'light blue': 'Bleu clair', 'sky blue': 'Bleu ciel', 'mist blue': 'Bleu brume',
    'rot': 'Rouge', 'red': 'Rouge',
    'gelb': 'Jaune', 'yellow': 'Jaune',
    'beige': 'Beige', 'orange': 'Orange', 'khaki': 'Kaki', 'burgundy': 'Bordeaux'
  });

  const normalize = (value) => String(value || '')
    .replace(/\u00a0/g, ' ')
    .trim()
    .toLocaleLowerCase('fr-FR');

  const translateExact = (value) => map[normalize(value)] || null;

  function translateTextElement(el) {
    if (!el || el.nodeType !== 1) return;
    const current = (el.textContent || '').trim();
    if (!current) return;

    // Preserve the separator used by the theme for the selected value.
    const m = current.match(/^([—–-]\s*)?(.*)$/);
    const prefix = m?.[1] || '';
    const body = m?.[2] || current;
    const translated = translateExact(body);
    if (translated && translated !== body) el.textContent = prefix + translated;
  }

  function scanSelectors(root = document) {
    const selector = [
      '.product__selectors .radio__legend__option-name',
      '.product__selectors [data-option-value]',
      '.product__selectors .option-title',
      '.product__selectors [data-popout-toggle-text]',
      '.product__selectors .select-popout__option span',
      '.product__selectors [data-camille-fr-option-text]'
    ].join(',');

    if (root.matches?.(selector)) translateTextElement(root);
    root.querySelectorAll?.(selector).forEach(translateTextElement);

    // Tooltips are attributes, not visible text nodes.
    root.querySelectorAll?.('.product__selectors [data-tooltip]').forEach((el) => {
      const translated = translateExact(el.getAttribute('data-tooltip'));
      if (translated) el.setAttribute('data-tooltip', translated);
    });
  }

  function removeOldForcedGuide() {
    // v35 temporarily injected a second size-guide control. v36 only keeps
    // the theme's native popup-component (the centred modal requested).
    document.querySelectorAll('.camille-forced-size-guide-link, .camille-forced-size-guide-row, #CamilleForcedSizeGuideDialog')
      .forEach((el) => el.remove());
  }

  function applyAll(root = document) {
    scanSelectors(root);
    removeOldForcedGuide();
  }

  function start() {
    applyAll(document);

    let queued = false;
    const observer = new MutationObserver((mutations) => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        for (const mutation of mutations) {
          if (mutation.type === 'characterData') {
            const parent = mutation.target.parentElement;
            if (parent) scanSelectors(parent.closest('.product__selectors') || parent);
          } else {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) scanSelectors(node);
            });
          }
        }
        removeOldForcedGuide();
      });
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
